const API_BASE = process.env.NEXT_PUBLIC_API_BASE || "http://localhost:8000";


export async function getStores(type = "cafeteria") {

  const params = new URLSearchParams();
  params.append("is_fnb", "true");

  if (type === "cafeteria") {
    params.append("is_cafeteria", "false");
  }

  if (type === "catering") {
    params.append("is_cafeteria", "true");
  }

  const res = await fetch(`${API_BASE}/stores?${params.toString()}`);
  const json = await res.json();

  if (!res.ok) {
    throw new Error(json.detail || "Failed to load stores");
  }

  const list = Array.isArray(json) ? json : [];

  return list.filter(
    (s) =>
      s.is_active === true ||
      s.is_active === 1 ||
      s.is_active === "1"
  );
}



export async function getStoreProducts(
  storeName,
  type = "cafeteria",
  cursor = null,
  search = "",
  limit = 6
) {

  const params = new URLSearchParams({
    limit: String(limit)
  });

  params.append("is_fnb", "true");

  if (type === "cafeteria") {
    params.append("is_cafeteria", "false");
  }

  if (type === "catering") {
    params.append("is_cafeteria", "true");
  }

  if (cursor) params.append("cursor", cursor);
  if (search) params.append("q", search);

  const res = await fetch(
    `${API_BASE}/stores/${encodeURIComponent(
      storeName
    )}/products?${params.toString()}`
  );

  const json = await res.json();

  if (!res.ok) {
    throw new Error(json.detail || "Failed to load products");
  }

  return json;
}